import React, { useState } from 'react';
import styled from 'styled-components';
import { t } from 'i18next';
import { useArticleDataState } from '../../../../../stores/Configuration/ArticleDataProvider'
import ModalComponent2 from '../../../../Modals/ModalComponent2';
import BigDataList from './BigDataList';
import { cloneDeep } from 'lodash';
import SizeModal from './SizeModal';
import LoadingOverlay from '../../../../Loading/LoadingOverlay';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import useMountEffect from '../../../../../utils/hooks/useMountEffect';
import { DragPrgeview } from '../../../ContingentTemplate/DragPrgeview'


const StyledWrapper = styled.div`
  .article-search {
    display: flex;
    flex-direction: row; /* Default flex direction (row) */
    width: 100%;
    overflow-x: hidden;

    @media screen and (max-width: 1500px) {
      flex-direction: column-reverse; /* On smaller screens, switch to column-reverse */
    }

    @media screen and (max-width: 1422px) and (min-width: 1081px) {
      width: 90%; /* Reduce the width in the 1422px to 1081px range */
      margin: 0 auto; /* Center the content horizontally */
    }
  }

  @media screen and (min-width: 1080px) {
    min-width: 600px;
  }

  /* Prevent horizontal scrolling */
  overflow-x: hidden;
`;

const SizeSystemsOverview = () => {
  const {
    bigData,
    setBigData,
    loadingStates,
    deleteSize,
    getSizeSystemTemplates, getSizes,
    putSizeSystemsOrderSequence, putSizesOrderSequence
  } = useArticleDataState();

  const [openEditSizeModal, setOpenEditSizeModal] = useState(null);
  const [openAddSizeModal, setOpenAddSizeModal] = useState(null);
  const [openDeleteSizeModal, setOpenDeleteSizeModal] = useState(null);


  useMountEffect(() => {
    getSizeSystemTemplates();
  });
  const getNewSequence = (fromId, toId, oldSequence) => {
    let fromIndex = oldSequence.findIndex((id) => id === fromId);
    let toIndex = oldSequence.findIndex((id) => id === toId);
    let copiedSequence = [...oldSequence];
    const elm = copiedSequence.splice(fromIndex, 1)[0];
    copiedSequence.splice(toIndex, 0, elm);
    return copiedSequence;
  };

  const moveCardHandler = (fromObj, toObj) => {
    if (!fromObj) {
      return;
    } else if (fromObj.type === toObj.type) {
      if (fromObj.type === 'system') {
        let oldSequence = Object.keys(bigData);
        const newSequence = getNewSequence(fromObj.id, toObj.id, oldSequence);
        putSizeSystemsOrderSequence(newSequence);
      } else if (fromObj.type === 'size') {
        let sizes = bigData[fromObj.systemId].sizes;
        let oldSequence = Object.keys(sizes);
        const newSequence = getNewSequence(fromObj.id, toObj.id, oldSequence);
        putSizesOrderSequence(fromObj.systemId, newSequence);
      }
    }
  };

  const changeOpenProp = (systemId, sizeId) => {
    if (sizeId) {
      setBigData((prev) => {
        let newData = cloneDeep(prev);
        newData[systemId].sizes[sizeId].open = !newData[systemId].sizes[sizeId].open;
        return newData;
      });
    } else {
      setBigData((prev) => {
        let newData = cloneDeep(prev);
        newData[systemId].open = !newData[systemId].open;
        return newData;
      });
    }
    let alreadyLoaded = bigData[systemId].sizesLoaded;
    if (!alreadyLoaded) {
      getSizes(systemId);
    }
  };

  return (
    <>
      <StyledWrapper>
        <DndProvider backend={HTML5Backend}>
          <DragPrgeview />
          <div style={{ border: '1px solid gray', flex: 2, overflow: 'auto' }}>
            <LoadingOverlay isLoading={loadingStates.saveOrderSequence || !bigData}>
              <BigDataList
                changeOpenProp={changeOpenProp}
                moveCardHandler={moveCardHandler}
                bigData={bigData}
                editSize={setOpenEditSizeModal}
                addSize={setOpenAddSizeModal}
                deleteSize={setOpenDeleteSizeModal}
              />
            </LoadingOverlay>
          </div>
        </DndProvider>
      </StyledWrapper>
      {openEditSizeModal && (
        <SizeModal
          sizeId={openEditSizeModal.sizeId}
          systemId={openEditSizeModal.systemId}
          handleClose={() => setOpenEditSizeModal(null)}
          editSize={bigData[openEditSizeModal.systemId].sizes[openEditSizeModal.sizeId]}
        />
      )}
      {openAddSizeModal && <SizeModal systemId={openAddSizeModal.systemId} handleClose={() => setOpenAddSizeModal(null)} />}
      {openDeleteSizeModal && (
        <ModalComponent2
          ModalTitle={t('sizeAdmin:deleteSize')}
          BodyPart1={t('sizeAdmin:deleteSizeBody')}
          button1Function={() => deleteSize(openDeleteSizeModal.systemId, openDeleteSizeModal.sizeId).then(() => setOpenDeleteSizeModal(null))}
          button1Text={t('delete')}
          button1Loading={loadingStates.deleteSize}
          button1Variant="danger"
          bodyStyle="alert alert-danger"
          functionCancel={() => {
            setOpenDeleteSizeModal(null);
          }}
        />
      )}
    </>
  );
};

export default SizeSystemsOverview;
